export function FullPageLoader({ className }: { className?: string }) {
  return (
    <div
      className={
        'fixed inset-0 z-50 flex items-center justify-center bg-black/30 backdrop-blur-sm ' +
        className
      }
    >
      <div className="w-16 h-16 rounded-full border-4 border-t-blue-500 border-r-transparent border-b-transparent border-l-transparent animate-spin" />
    </div>
  );
}
